export const Published = {
	NotVisible: 0,
	Visible: 1,
};
export const Priority = {
	Low: 0,
	Medium: 1,
	High: 2,
};
export const Status = {
	Open: 0,
	UnderReview: 1,
	Planned: 2,
	InProgress: 3,
	Live: 4,
	Closed: 5,
};
export const Module = {
	Home: 0,
	News: 1,
	Dashboard: 2,
	Schedule: 3,
	Flights: 4,
	Aircraft: 5,
	Users: 6,
	Courses: 7,
	Invoices: 8,
	Sms: 9,
	Reports: 10,
	Mailing: 11,
	Documents: 12,
	Camo: 13,
	Admin: 14,
};
export const Role = {
	Unauthorized: 0,
	User: 1,
	Admin: 2,
};
